import React, { Component } from 'react';

import { Badge } from 'reactstrap';

import classNames from 'classnames';


const DEFAULT_COLON = ':';

export function getLang() {
  let lang = (navigator.languages !== undefined) ? navigator.languages[0] : navigator.language;
  
  // lang = 'ar-EG';
  if (!!lang.match(/ar|EG|ar-EG/gi))
    lang = 'en-US';
  
  // lang = 'en-US';
  return lang;
}

function isNumber(value) {
  const number = Number(value);
  return !isNaN(number) && String(value) === String(number);
}

function formatTimeItem(value) {
  return `${value || ''}00`.substr(0, 2);
}

function validateTimeAndCursor(
  showSeconds = false,
  value = '',
  defaultValue = '',
  colon = DEFAULT_COLON,
  cursorPosition = 0,
  meridianMode = false
) {
  const [oldH, oldM, oldS] = defaultValue.split(colon);

  let newCursorPosition = Number(cursorPosition);
  let [newH, newM, newS] = String(value).split(colon);

  newH = formatTimeItem(newH);
  
  const maxH = meridianMode ? 1 : 2;
  const maxH1 = meridianMode ? 2 : 3;
  
  if (Number(newH[0]) > maxH) {
    newH = oldH;
    newCursorPosition -= 1;
  } else if (Number(newH[0]) === maxH) {
    if (Number(oldH[0]) === maxH && Number(newH[1]) > maxH1) {
      newH = `${maxH}${oldH[1]}`;
      newCursorPosition -= 2;
    } else if (Number(newH[1]) > maxH1) {
      newH = meridianMode ? '12' : '23';
    }
  }

  newM = formatTimeItem(newM);
  if (Number(newM[0]) > 5) {
    newM = oldM;
    newCursorPosition -= 1;
  }

  if (showSeconds) {
    newS = formatTimeItem(newS);
    if (Number(newS[0]) > 5) {
      newS = oldS;
      newCursorPosition -= 1;
    }
  }

  const validatedValue = showSeconds ? `${newH}${colon}${newM}${colon}${newS}` : `${newH}${colon}${newM}`;

  return [validatedValue, newCursorPosition];
}

class TimePicker extends Component {
  constructor(props) {
    super(props);
    this.onTimeChange = this.onTimeChange.bind(this);
    this.toggleMeridiem = this.toggleMeridiem.bind(this);
    
    this.state = this.getInitialState();
  }
  
  getMeridiem (value){
    const hour = value.getHours();
    return hour >= 12 ? "PM" : "AM";
  }
  
  componentWillReceiveProps (nextProps){
    if (nextProps.value !== this.props.value)
      this.setState({value: nextProps.value});
  }
  
  toggleMeridiem (){
    const { value, meridianMode } = this.state;
    if (meridianMode === false)
      return
    
    const hours = value.getHours();
    
    if (hours > 12)
      value.setHours(hours - 12);
    else
      value.setHours(hours + 12);
    
    this.changeValue(value);
  }
  
  changeValue(value, cb){
    const { onChange } = this.props;
    
    this.setState({ value }, cb);
    onChange && onChange(value);
    return
  }
  
  formatTime(time, locale) {
    return (time && time.toLocaleTimeString(locale, {hour: '2-digit', minute: '2-digit'}).replace(/[^0-9:.]+/gi, '')) || '';
  }
  
  getInitialState() {
    const today = new Date();
    const locale = this.props.locale || getLang();
    const value = this.props.value || today;
    const meridianMode = !value.toLocaleTimeString(locale, {hour: '2-digit', minute: '2-digit'}).match(/^[0-9:.\s+]+$/gi);
    
    return {
      value,
      locale,
      colon: DEFAULT_COLON,
      meridianMode
    };
  }
  
  onTimeChange (event){
    const { meridianMode, colon, locale } = this.state;
    const oldValue = this.formatTime(this.state.value, locale); 
    const inputEl = event.target;
    const inputValue = inputEl.value;
    const position = inputEl.selectionEnd || 0;
    const isTyped = inputValue.length > oldValue.length;
    const cursorCharacter = inputValue[position - 1];
    const addedCharacter = isTyped ? cursorCharacter : null;
    const removedCharacter = isTyped ? null : oldValue[position];
    const replacedSingleCharacter = inputValue.length === oldValue.length ? oldValue[position - 1] : null;
    
    let newValue = oldValue;
    let newPosition = position;

    if (addedCharacter !== null) {
      if (position > this.state._maxLength) {
        newPosition = this.state._maxLength;
      } else if ((position === 3 || position === 6) && addedCharacter === colon) {
        newValue = `${inputValue.substr(0, position - 1)}${colon}${inputValue.substr(position + 1)}`;
      } else if ((position === 3 || position === 6) && isNumber(addedCharacter)) {
        newValue = `${inputValue.substr(0, position - 1)}${colon}${addedCharacter}${inputValue.substr(position + 2)}`;
        newPosition = position + 1;
      } else if (isNumber(addedCharacter)) {
        // user typed a number
        newValue = inputValue.substr(0, position - 1) + addedCharacter + inputValue.substr(position + 1);
        if (position === 2 || position === 5) {
          newPosition = position + 1;
        }
      } else {
        // if user typed NOT a number, then keep old value & position
        newPosition = position - 1;
      }
    } else if (replacedSingleCharacter !== null) {
      // user replaced only a single character
      if (isNumber(cursorCharacter)) {
        if (position - 1 === 2 || position - 1 === 5) {
          newValue = `${inputValue.substr(0, position - 1)}${colon}${inputValue.substr(position)}`;
        } else {
          newValue = inputValue;
        }
      } else {
        // user replaced a number on some non-number character
        newValue = oldValue;
        newPosition = position - 1;
      }
    } else if (typeof cursorCharacter !== 'undefined' && cursorCharacter !== colon && !isNumber(cursorCharacter)) {
      // set of characters replaced by non-number
      newValue = oldValue;
      newPosition = position - 1;
    } else if (removedCharacter !== null) {
      if ((position === 2 || position === 5) && removedCharacter === colon) {
        newValue = `${inputValue.substr(0, position - 1)}0${colon}${inputValue.substr(position)}`;
        newPosition = position - 1;
      } else {
        // user removed a number
        newValue = `${inputValue.substr(0, position)}0${inputValue.substr(position)}`;
      }
    }
    
    const [validatedTime, validatedCursorPosition] = validateTimeAndCursor(
      false,
      newValue,
      oldValue,
      colon,
      newPosition,
      meridianMode
    );
    
    this.setTime(validatedTime, () => {
      inputEl.selectionStart = validatedCursorPosition;
      inputEl.selectionEnd = validatedCursorPosition;
    });
    
    event.persist();
  }
  
  setTime(time, cb) {
    const { value, meridianMode, colon } = this.state;
    
    let [hours, minutes] = time.split(colon);
    const meridiem = this.getMeridiem(value);
    
    hours = parseInt(hours, 10);
    if (meridianMode === true){
      if ( meridiem === 'PM' && hours < 12){
        hours = hours + 12
      }
      else if (meridiem === 'AM' && hours === 12){
        hours = 0
      }
    }
    
    value.setHours(hours);
    value.setMinutes(minutes);
    
    this.changeValue(value, cb);
  }
  
  
  render() {
    const { value, locale, meridianMode } = this.state;
    
    return (
      <div className={classNames({"form-control": true, "time-picker": true, meridian: meridianMode})}>
        <input value={(value && this.formatTime(value, locale)) || ''} onChange={this.onTimeChange} />
        {meridianMode && <Badge size="sm" onClick={this.toggleMeridiem}>{this.getMeridiem(value)}</Badge>}
      </div>
    );
  }
};

export default TimePicker;


// WEBPACK FOOTER //
// ./src/components/helpers/TimePicker.js